import CustomProviderLogo from './CustomProviderLogo';

export default CustomProviderLogo;
